export const QUERY_LIMIT = 50000;


export const initialFileData: {
  file: File | null,
  name: string
} = {
  file: null,
  name: "Выберите файл",
};

export const initialUploadStatus: {
  message: string,
  status: boolean,
  variant: 'success' | 'info' | 'error',
} = {
  message: "",
  status: false,
  variant: 'info',
};
